import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getRolesKey } from '../../utils/keys';
export const useRoles = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const spaceRolesKey = getRolesKey(variables);
    return useQuery(spaceRolesKey, () => client.roles.list(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useRoles.js.map